import './cartItem.css'
import { incrementQuantity, decrementQuantity, removeItem} from '../../store/cartSlice'
import { useDispatch } from 'react-redux'

function CartItem({id, cover, name, price, quantity=0, about, stars}) {
  const dispatch = useDispatch()

  return (
    <div className="cartItem ">
   <div className="Grid3">
            <div className="cartItem-image">
                <img src={cover} alt='item' />
            </div>

            <div className="cartItem-info">
                <div className="griD-2">
                    <div className="Item-info">
                      <p className="cartItem__title">{name}</p>
                      <p className="cartItem__price">
                      <small>$</small>
                      <strong>{price}</strong>
                      </p>
                      <p className='cartItem__about'>{about}</p>
                      <p className='item-stars'>{stars}<i className='fa fa-star'></i></p>
                    </div>

                    <div className='cartItem__incrDec'>
                      <button onClick={() => dispatch(decrementQuantity(id))}>-</button>
                        <p>{quantity}</p>
                      <button onClick={() => dispatch(incrementQuantity(id))}>+</button>
                    </div>

                    <button
                       className='cartItem__removeButton' 
                       onClick={() => dispatch(removeItem(id))}>
                         Remove
                    </button>

                </div>
            </div>
        </div>
            <div className="subtotal">
                <h3>Items: {quantity}</h3>
                <h3>Price: $ <strong>{price}</strong></h3>

                <div className="subtotal-amount">
                    <h4>Subtotal</h4>
                    <p>$ {price * quantity}</p>
                </div>
            </div>
    
      </div>

  )
}

export default CartItem